<template>
    <v-card>
        <v-card-title>
            <div class="mr-3">{{$t('event.faq')}}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddFaq">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="tableFaq"
                      :loading="isFaqPending"
                      @pagination="currentPagination"
                      >
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.order="{value}">
                {{value}}
            </template>
            <template v-slot:item.answer="{value}">
                <froalaView v-model="value" class="popup-preview"></froalaView>
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                       @click="initEditFaq(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                       @click="deleteFaq(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="editFaqDialogShown"
                  max-width="600px"
                  persistent
                  scrollable
                  :retain-focus="false"
                  >
            <v-card>
                <v-card-title>
                    {{$t('event.faq')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditFaqFormValid">
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('event_faq.category')"
                                                  :placeholder="$t('event_faq.category')"
                                                  v-model="editingFaq.category"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_faq.question') + ' EN'"
                                        :placeholder="$t('event_faq.question') + ' EN'"
                                        v-model="editingFaq.question"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_faq.answer')}} EN</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingFaq.answer"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_faq.question') + ' TC'"
                                        :placeholder="$t('event_faq.question') + ' TC'"
                                        v-model="editingFaq.question_tc"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_faq.answer')}} TC</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingFaq.answer_tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_faq.question') + ' SC'"
                                        :placeholder="$t('event_faq.question') + ' SC'"
                                        v-model="editingFaq.question_sc"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_faq.answer')}} SC</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingFaq.answer_sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmSaveItemDialogShown = true"
                           :disabled="!isEditFaqFormValid">{{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <PopupAlert 
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditFaqItem"
            :onNo="function() {confirmCancelItemDialogShown=false;}"
            ></PopupAlert>
        <PopupAlert 
            v-model="confirmSaveItemDialogShown"
            title="Confirm"
            message="Do you wish to confirm to save your faq?"
            :onYes="saveFaq"
            :onNo="function() {confirmSaveItemDialogShown=false;}"
            ></PopupAlert>
    </v-card>
</template>

<style scoped>
    .button-spacer {
        width:10px;
    }
</style>

<script>
    import {computed, ref, onMounted} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import {cloneDeep} from "lodash";
    import PopupAlert from "../../components/PopupAlert";
    import Sortable from "sortablejs";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventFaq',
        components:{PopupAlert},
        setup(props, {root}) {
            const {EventFaq} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const eventId = computed(() => root.$route.params.eventId);

            const faqParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                        $sort: {order: 1},
                    }
                }
            });
            const {items: faqItems, isPending: isFaqPending} = useFind({
                model: EventFaq,
                params: faqParams,
            });
            // Data Table
            const headers = ref([
                {text: '', value: 'scroller', width: 80},
                {text: root.$t('event_faq.order'), value: 'order'},
                {text: root.$t('event_faq.category'), value: 'category'},
                {text: root.$t('event_faq.question'), value: 'question'},
                {text: root.$t('event_faq.answer'), value: 'answer', width: '300px'},
                {text: '', value: 'actions'},
            ]);

            // Order
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderFaq = ref([]);
            const overlay = ref(false);

            // Add / Edit Faq
            const editFaqDialogShown = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const confirmSaveItemDialogShown = ref(false);
            const isEditFaqFormValid = ref(false);
            const editingFaq = ref(new EventFaq({eventId: eventId.value}));
            const initAddFaq = function () {
                editingFaq.value = new EventFaq({eventId: eventId.value});
                editingFaq.value.order = faqItems.value.length + 1;
                editFaqDialogShown.value = true;
            };
            const initEditFaq = function (faq) {
                editingFaq.value = cloneDeep(faq);
                editFaqDialogShown.value = true;
            };
            const deleteFaq = function (faq) {
                if (confirm(root.$t('event_faq.confirm_delete'))) {
                    faq.remove();
                }
            };
            const saveFaq = async function () {
                editingFaq.value.save().then(() => {
                    EventFaq.get(editingFaq.value.id);
                    editFaqDialogShown.value = false;
                    confirmSaveItemDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('event_faq.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const cancelEditFaqItem = function(){
                editFaqDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }

            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderFaq.value = cloneDeep(sortedFaq.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                console.log("editOrderFaq:",editOrderFaq.value)
                for(let i=0;i<editOrderFaq.value.length;i++){
                    await editOrderFaq.value[i].save().then(()=>{
                        EventFaq.get(editOrderFaq.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortFaq = function(sortFaq){
                if(sortFaq.length<2){
                    return sortFaq
                }

                const chosenIndex = sortFaq.length - 1
                const chosen  = sortFaq[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortFaq[i].order
                    temp < chosen.order ? a.push(sortFaq[i]) : b.push(sortFaq[i])
                }
                const output = [...quickSortFaq(a),chosen,...quickSortFaq(b)]
                return output
            }

            const sortedFaq = computed(()=>{
                return quickSortFaq(faqItems.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderFaq.value.splice(oldIndex,1)[0];
                            editOrderFaq.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderFaq.value.length;i++){
                                editOrderFaq.value[i].order = i+1
                            }
                            editOrderFaq.value = quickSortFaq(editOrderFaq.value);
                        }
                    }
                )
            });

            const tableFaq = computed(()=>{
                return isEditOrderMode.value?editOrderFaq.value:sortedFaq.value
            })

            return {
                faqItems,
                isFaqPending,

                headers,
                tableFaq,

                editFaqDialogShown,
                confirmCancelItemDialogShown,
                confirmSaveItemDialogShown,
                initAddFaq,
                initEditFaq,
                deleteFaq,
                isEditFaqFormValid,
                editingFaq,
                saveFaq,
                cancelEditFaqItem,

                DateTime,
                getFileUrl: root.$getFileURL,

                previewHtmlContentOption,
                currentPagination,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                isEditOrderMode,
                overlay,

                showEditor,
                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
